import { render, staticRenderFns } from "./insuredChange.vue?vue&type=template&id=b2f914ac&scoped=true"
import script from "./insuredChange.vue?vue&type=script&lang=js"
export * from "./insuredChange.vue?vue&type=script&lang=js"
import style0 from "./insuredChange.vue?vue&type=style&index=0&id=b2f914ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f914ac",
  null
  
)

export default component.exports